
import { useEffect, useState } from 'react';
import { useQuery } from 'urql';
import { get } from 'lodash';

export const useData = (queryObject, variables, params = {}) => {
  const query = get(queryObject, 'query');
  const reducer = get(queryObject, 'reducer', (res) => res);
  // https://formidable.com/open-source/urql/docs/api/urql/#usequery
  const [result, executeQuery] = useQuery({
    query,
    variables,
    ...params,
  });

  let data = get(result, 'data');
  if (data) data = reducer(data); // reduce data if present

  return {
    ...result,
    reexecuteQuery: executeQuery,
    data: get(data, 'nodes', data),
  };
};

export const usePaginatedData = (queryObject, variables = {}, params = {}) => {
  const query = get(queryObject, 'query');
  const reducer = get(queryObject, 'reducer', (res) => res);
  const initialCursors = get(variables, 'cursors', {});

  const [cursors, setCursors] = useState(initialCursors);

  useEffect(() => {
    setCursors({});
  }, [variables]);

  const [result, executeQuery] = useQuery({
    query,
    variables: {
      ...variables,
      ...cursors,
    },
    ...params,
  });

  // handle data reduction
  let data = get(result, 'data');
  if (data) data = reducer(data); // reduce data if present

  // handle pagination
  /** handle pagination relies on paginated queries to provide a reducer
   * because pageInfo lived at result.data.queryName.pageInfo
   * here  we have no knowledge of pageInfo so the implementation is brittle
   * and order dependent; @TODO add queryName to query objects */
  const hasNextPage = get(data, 'pageInfo.hasNextPage', false);
  const hasPreviousPage = get(data, 'pageInfo.hasPreviousPage', false);
  const startCursor = get(data, 'pageInfo.startCursor', undefined);
  const endCursor = get(data, 'pageInfo.endCursor', undefined);

  const loadNextPage = () => {
    setCursors({
      after: endCursor,
      before: undefined,
    });
  };

  const loadPrevPage = () => setCursors({
    after: undefined,
    before: startCursor,
  });

  // @TODO repack the response object
  return {
    ...result,
    data: get(data, 'nodes', data),
    reexecuteQuery: executeQuery,
    hasNextPage,
    hasPreviousPage,
    loadNextPage,
    loadPrevPage,
  };
};
